import { useEffect } from 'react';

// OAuth redirect target for the Dropbox PKCE popup flow (see
// helpers/dropbox.ts). Relays the one-time authorization code back to the
// opener window and closes itself. The code is useless without the PKCE
// verifier, which only the opener holds.
export const DropboxCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    window.opener?.postMessage(
      {
        type: 'dropbox-oauth',
        code: params.get('code') || undefined,
        state: params.get('state') || undefined,
        error: params.get('error') || undefined,
      },
      window.location.origin,
    );
    window.close();
  }, []);

  return (
    <p style={{ padding: 24, textAlign: 'center' }}>
      You can close this window.
    </p>
  );
};
